import BaseAPI from './base'

class SubmitExerciseAPI extends BaseAPI {}

export default new SubmitExerciseAPI('v1/submit-exercises', 'SubmitExercise')
